import { useEffect, useRef, useState } from 'react';

/**
 * Local draft for typed inputs: shows keystrokes immediately and commits after a pause
 * (or at once via `flush`). Re-syncs when the committed value changes from outside
 * (chip removed, Clear all, back button).
 */
export default function useDebouncedCommit(value, onCommit, delay = 350) {
    const [draft, setDraft] = useState(value);
    const timer = useRef(null);
    const commitRef = useRef(onCommit);
    commitRef.current = onCommit;

    // Compare by content: range values arrive as fresh objects on every render.
    const valueKey = JSON.stringify(value ?? null);
    useEffect(() => {
        setDraft(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [valueKey]);

    useEffect(() => () => clearTimeout(timer.current), []);

    const change = (next) => {
        setDraft(next);
        clearTimeout(timer.current);
        timer.current = setTimeout(() => commitRef.current(next), delay);
    };
    const flush = () => {
        clearTimeout(timer.current);
        commitRef.current(draft);
    };
    return [draft, change, flush];
}
